import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractApiService } from './abstract-api.service';
import { NGXLogger } from 'ngx-logger';
import { ArchivesLevels, ArchivesProfiles, ArchivesRegions, ArchivesSites, ArchivesZones } from '../../models/api/archives/archives-api-model';

@Injectable({
  providedIn: 'root',
})
export class ArchivesService extends AbstractApiService {
  private readonly endpoint = '/archives';

  constructor(
    protected override http: HttpClient,
    protected override logger: NGXLogger
  ) {
    super(http, logger);
  }

  getLevels() {
    return this.fetch<ArchivesLevels>(`${this.endpoint}`, {archive: 'levels'});
  }

  getRegions() {
    return this.fetch<ArchivesRegions>(`${this.endpoint}`, {archive: 'regions'});
  }

  getConsumptionProfiles() {
    return this.fetch<ArchivesProfiles>(`${this.endpoint}`, {archive: 'sites_consumption_profile'});
  }

  getProductionProfiles() {
    return this.fetch<ArchivesProfiles>(`${this.endpoint}`, {archive: 'sites_production_profile'});
  }

  getSiteTypes() {
    return this.fetch<ArchivesSites>(`${this.endpoint}`,{archive: 'sites_type'});
  }

  getZones() {
    return this.fetch<ArchivesZones>(`${this.endpoint}`,{archive: 'zones'});
  }
}
